import { InputCheckbox } from '@creditornot/cb-checkbox';
import styled from 'styled-components';

const LargeCheckBox = styled(InputCheckbox)`
  --size: 24px;
`;

export default LargeCheckBox;
